export default __webpack_public_path__ + "static/media/bell.bed6c3ea.svg";